var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoOnly(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_384_128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.9049 45.4667L40.3674 16.7167C40.1768 14.551 38.3924 12.9167 36.2174 12.9167C35.7178 12.9167 35.3112 13.3229 35.3112 13.8229V18.3052C35.3112 18.7489 34.9758 19.1364 34.5331 19.1646C34.0477 19.1958 33.6445 18.8114 33.6445 18.3333V8.64582C33.6445 3.87811 29.7664 -1.52588e-05 24.9987 -1.52588e-05C20.231 -1.52588e-05 16.3529 3.87811 16.3529 8.64582V12.9167H13.7799C11.6049 12.9167 9.82056 14.551 9.62994 16.7167L7.09244 45.4667C6.8789 47.8963 8.79483 50 11.2435 50H38.7539C41.2029 50 43.1185 47.896 42.9049 45.4667ZM20.207 44.4791H14.1654C13.7051 44.4791 13.332 44.106 13.332 43.6458C13.332 43.1856 13.7051 42.8125 14.1654 42.8125H20.207C20.6672 42.8125 21.0404 43.1856 21.0404 43.6458C21.0404 44.106 20.6672 44.4791 20.207 44.4791ZM20.207 40.3125H14.1654C13.7051 40.3125 13.332 39.9394 13.332 39.4791C13.332 39.0189 13.7051 38.6458 14.1654 38.6458H20.207C20.6672 38.6458 21.0404 39.0189 21.0404 39.4791C21.0404 39.9394 20.6672 40.3125 20.207 40.3125ZM31.9779 12.9167H20.5924C20.0924 12.9167 19.6862 13.3229 19.6862 13.8229V18.3052C19.6862 18.7489 19.3508 19.1364 18.9081 19.1646C18.4226 19.1958 18.0195 18.8114 18.0195 18.3333V8.64582C18.0195 4.7979 21.1508 1.66665 24.9987 1.66665C28.8466 1.66665 31.9779 4.7979 31.9779 8.64582V12.9167Z",
    fill: "#32C33B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_384_128"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOnly);
export default __webpack_public_path__ + "static/media/logo-only.0d53c4df71abc5a008bd6450b8cfc207.svg";
export { ForwardRef as ReactComponent };